import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/button-icons/tick-icon-pink.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-175660d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ad-hoc-reports-picker" }
const _hoisted_2 = { class: "users-container scrollbar" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "selected user"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["disabled"]

import { Modal } from "uiv";
import { ref, watch, watchEffect } from "vue";
import { useToggle } from "../../composables/useToggle";
import { useAxios } from "../../composables/api";
import { Analytics } from "../../services/analytics/analytics";
import { ShortUserDetailsApiModel } from "../../api-models";
import { csContext } from "../../services/cs-context";


export default /*#__PURE__*/_defineComponent({
  __name: 'ad-hoc-report-picker',
  props: {
    shown: { type: Boolean }
  },
  emits: ["select", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedUsers = ref<ShortUserDetailsApiModel[]>([]);

const { state, toggleState } = useToggle(false);

const { data } = useAxios<ShortUserDetailsApiModel[]>("/api/reportcreation/users-for-adhoc-groups");

const handleSelectedUser = (user: ShortUserDetailsApiModel): void => {
  const index = selectedUsers.value.indexOf(user);
  if (index === -1) selectedUsers.value.push(user);
  else {
    selectedUsers.value.splice(index, 1);
  }
};

const handleConfirm = (): void => {
  if (selectedUsers.value.length >= 2) {
    const name = "Ad Hoc Group";
    const userIds = selectedUsers.value.map((u) => u.id).join(",");
    const url = `/ad-hoc-group-report/${name}/${userIds}`;
    window.open(url, "_blank");
    emit("close");
  }
  // if (selectedComparison.value) {
  //   const url = `/SoloReport/Compare/${data.value?.first.reportType}/${props.reportEntityId}/${selectedComparison.value.reportType}/${selectedComparison.value.reportId}`;
  //   Analytics.actionAsync("Clicked Confirm Compare Reports", "CompareReports", {
  //     isReportOnSelf: props.isReportOnSelf,
  //     reportType: props.reportType,
  //     reportEntityId: props.reportEntityId,
  //     secondReportType: selectedComparison.value.reportType,
  //     secondReportEntityId: selectedComparison.value.reportId,
  //   }).then(() => {
  //     window.location.href = url;
  //   });
  // }
};

watchEffect(() => {
  state.value = props.shown;
});

watch(state, (newValue) => {
  if (!newValue) {
    emit("close");
  }

  const eventName = newValue
    ? "Clicked Open Ad Hoc Group Reports"
    : "Clicked Cancel Ad Hoc Group Reports";
  Analytics.action(eventName, "AdHocGroupReports", {
    includesSelf: !!selectedUsers.value.find((u) => u.id === csContext.user.id),
    numberOfUsers: selectedUsers.value.length,
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Modal), {
      modelValue: _unref(state),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(state) ? (state).value = $event : null)),
      title: "Select people to include in the report..",
      "data-test": "ad-hoc-report-picker-modal"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("button", {
          onClick: handleConfirm,
          class: "btn btn-primary",
          disabled: selectedUsers.value.length < 2,
          "data-test": "ad-hoc-report-picker-confirm-button"
        }, " Confirm ", 8, _hoisted_7),
        _createElementVNode("button", {
          class: "btn btn-default",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggleState) && _unref(toggleState)(...args))),
          "data-test": "ad-hoc-report-picker-cancel-button"
        }, " Cancel ")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (user) => {
            return (_openBlock(), _createElementBlock("div", {
              key: user.id,
              class: "user"
            }, [
              _createElementVNode("button", {
                class: "btn btn-default",
                onClick: ($event: any) => (handleSelectedUser(user)),
                "data-test": "ad-hoc-report-picker-choice"
              }, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 9, _hoisted_3),
              (selectedUsers.value.indexOf(user) !== -1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})